<template>
  <div></div>
</template>

<script>
import { AuthService } from '@/services/auth.service'
import keyStore from '@/constant/storeKey'
export default {
  name: 'SSO_AUTH',
  data: () => {
    return {}
  },
  async created () {
    try {
      var queryString = this.$route.query
      const tokenFirebase = localStorage.getItem('tokenFirebase')
      if (tokenFirebase) {
        queryString.webNotificationToken = tokenFirebase
      }
      const res = await AuthService.ssoAuth(queryString)

      console.log(res);

      localStorage.setItem(keyStore.IS_LOGIN_SSO, 'true')
      window.opener.postMessage('smallWindowDone', '*')
    } catch (error) {
      window.opener.postMessage(error.message, '*')
    } finally {
      // no-thing
    }
  }
}
</script>
